import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53524)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M49.9994 25H-0.000488281V9.48271C-0.000488281 9.00664 0.385546 8.62061 0.861619 8.62061H49.1374C49.6135 8.62061 49.9995 9.00664 49.9995 9.48271L49.9994 25Z",
				fill: "#C8414B"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M-0.000488281 25H49.9994V40.5173C49.9994 40.9933 49.6134 41.3794 49.1373 41.3794H0.861619C0.385546 41.3794 -0.000488281 40.9933 -0.000488281 40.5173V25Z",
				fill: "#F3F3F3"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53524",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgIdFlag);
export { ForwardRef as ReactComponent };
